import { useLingui, Trans } from '../../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import EmailActionLayout from '../../../components/molecules/EmailActionLayout.mjs';
import { useResetResendPasswordActions } from './useResetResendPasswordActions.mjs';

const PasswordBreached = ()=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    const { email, resendResetPassword, sendMagicLink, goBack } = useResetResendPasswordActions();
    return /*#__PURE__*/ React__default.createElement(EmailActionLayout, {
        header: $__i18n._({
            id: "password.breached.title"
        }),
        description: /*#__PURE__*/ React__default.createElement(Trans, {
            id: "password.breached.content",
            message: "A different site where you use the same password had a security issue recently. For your safety, an email was sent to you at <bold>{email}</bold> to reset your password.",
            components: {
                bold: /*#__PURE__*/ React__default.createElement("b", null)
            },
            values: {
                email
            }
        }),
        resend: resendResetPassword,
        sendMagicLink: sendMagicLink,
        goBack: goBack
    });
};

export { PasswordBreached };
//# sourceMappingURL=PasswordBreached.mjs.map
